module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-rural-1bfc66cbad3734da2ad7f388554afadf.svg";